import React, { FunctionComponent, useEffect, useState, Fragment, useRef } from 'react';
import Logo from '../../../assets/img/logodeveloper-pequeño.png';
import faUserCircle2 from '../../../assets/img/icono.png';
import { Row, Col, Dropdown, Form, Image, Modal, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faTerminal, faUserCircle, faBars } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useHistory } from 'react-router-dom';
import SessionExpired from '../../Modals/sessionExpired';
import InactivityModal from '../../Modals/inactivityModal';
import Cookies from 'universal-cookie';
import SessionService from '../../../services/SessionsService';
import ReactGA from 'react-ga4';
import AddOrganizationModal from '../../Modals/addOrganizationModal';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
import "./style.css"

import logo1 from "../../../assets/img/logos/AVAP_DeveloperPortal.svg"
import logoWhite from "../../../assets/img/logos/AVAP_DeveloperPortal_w.svg"

import AddOrganizationSlots from '../../Modals/addOrganizationSlots';
import config from '../../../configs/appConfig.json'

import WorkspaceMenu from './WorkspaceMenu';

import icn_grid_w from '../../../assets/img/ui_icons/icn_grid.svg'
import icn_grid_w_b from '../../../assets/img/ui_icons/icn_grid_b.svg'


import sun from '../../../assets/img/ui_icons/sun.svg'
import moon from '../../../assets/img/ui_icons/moon.svg'
import bell from '../../../assets/img/ui_icons/bell.svg'

import icon_org from '../../../assets/img/ui_icons/icono-organization.svg'
import icon_org_w from '../../../assets/img/ui_icons/icono-organization-w.svg'


import arrowMenu_W from '../../../assets/img/ui_icons/menuArrow_W.svg';
import arrowMenu_B from '../../../assets/img/ui_icons/menuArrow_B.svg';

import cld_icn from '../../../assets/img/logos/AVAP_Commander1.svg'
import cld_icn_dark from '../../../assets/img/logos/AVAP_Commander_white.svg'

//iconos Negros


import Dashboard_B from '../../../assets/img/ui_icons/cld_dashboard-b.svg';
import Organizations_B from '../../../assets/img/ui_icons/cld_org-b.svg';

import IAM_W from '../../../assets/img/ui_icons/cld-IAM-w.svg';
import IAM_B from '../../../assets/img/ui_icons/cld-IAM-b.svg';

import Teams_B from '../../../assets/img/ui_icons/cld_teams-b.svg';
import Developers_B from '../../../assets/img/ui_icons/cld_devs-b.svg';
import Projects_B from '../../../assets/img/ui_icons/cld_apiprojects-b.svg';
import Publisher_B from '../../../assets/img/ui_icons/cld_publisher-b.svg';
import Sub_B from '../../../assets/img/ui_icons/cld_sub-b.svg';
import Upgrade_B from '../../../assets/img/ui_icons/cld_upgrade-b.svg';
import Billing_B from '../../../assets/img/ui_icons/cld_billing-b.svg';
import Tutorial_B from '../../../assets/img/ui_icons/cld_tutorial-b.svg';
import SignOut_B from '../../../assets/img/ui_icons/cld_singout-b.svg';
import cManager_B from '../../../assets/img/ui_icons/credentials-b.svg';
import rManager_B from '../../../assets/img/ui_icons/repo-b.svg';
import catalog_B from '../../../assets/img/ui_icons/catalog-b.svg';
import gateway_B from '../../../assets/img/ui_icons/gateway-b.svg';
import devPortal_B from '../../../assets/img/ui_icons/portal-b.svg';
import money_B from '../../../assets/img/ui_icons/coin-b.svg';
import analytics_B from '../../../assets/img/ui_icons/graph-b.svg';


//iconos Blancos
import Dashboard_W from '../../../assets/img/ui_icons/cld_dashboard-w.svg';
import Organizations_W from '../../../assets/img/ui_icons/cld_org-w.svg';
import Teams_W from '../../../assets/img/ui_icons/cld_teams-w.svg';
import Developers_W from '../../../assets/img/ui_icons/cld_devs-w.svg';
import Projects_W from '../../../assets/img/ui_icons/cld_apiprojects-w.svg';
import Publisher_W from '../../../assets/img/ui_icons/cld_publisher-w.svg';
import Sub_W from '../../../assets/img/ui_icons/cld_sub-w.svg';
import Upgrade_W from '../../../assets/img/ui_icons/cld_upgrade-w.svg';
import Billing_W from '../../../assets/img/ui_icons/cld_billing-w.svg';
import Tutorial_W from '../../../assets/img/ui_icons/cld_tutorial-w.svg';
import SignOut_W from '../../../assets/img/ui_icons/cld_singout-w.svg';
import cManager_W from '../../../assets/img/ui_icons/credentials-w.svg';
import rManager_W from '../../../assets/img/ui_icons/repo-w.svg';
import catalog_W from '../../../assets/img/ui_icons/catalog-w.svg';
import gateway_W from '../../../assets/img/ui_icons/gateway-w.svg';
import devPortal_W from '../../../assets/img/ui_icons/portal-w.svg';
import money_W from '../../../assets/img/ui_icons/coin-w.svg';
import analytics_W from '../../../assets/img/ui_icons/graph-w.svg';

import ia_W from '../../../assets/img/ui_icons/cld_ai-w.svg';
import ia_B from '../../../assets/img/ui_icons/cld_ai-b.svg';


import graph_W from '../../../assets/img/ui_icons/cld_aiCharts-w.svg';
import graph_B from '../../../assets/img/ui_icons/cld_aiCharts-b.svg';




//cloudNote: Top NavBar



interface HeaderProps {
  isDashboardBlue?: any; // Aquí especificas que 'sider' puede ser de cualquier tipo
}

const Header: FunctionComponent<HeaderProps> = ({ isDashboardBlue = false }) => {

  const history = useHistory();
  const [isLoggedIn, setLogged] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [inactivity, setInactivity] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [nombreOrganizacion, setNameOrg] = useState('');
  const [currentOrganizations, setCurrentOrganizations] = useState(0);
  const [maxOrganizations, setMaxOrganizations] = useState(0);
  const cookies = new Cookies();
  const [showWorkspaceMenu, setShowWorkspaceMenu] = useState(false);
  const menuAnchorRef = useRef(null);

  const [isDarkMode, setIsDarkMode] = useState(false); // Estado para el modo oscuro
  const [currentTheme, setCurrentTheme] = useState('dark');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Estado para el menú móvil
  const mobileMenuRef = useRef(null); // Referencia para el menú móvil
  let delay = 0;
  const [delayClick, setDelayClick] = useState(0)

  const toggleWorkspaceMenu = () => {
    if (delayClick == 0) setShowWorkspaceMenu(!showWorkspaceMenu);
    else {
      setDelayClick(0);
    }
  }


  // Función para alternar el menú móvil
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);

    // Si estamos cerrando el menú, asegurarnos de que el body pueda hacer scroll
    if (mobileMenuOpen) {
      document.body.style.overflow = '';
    } else {
      // Si estamos abriendo el menú, prevenir scroll del body solo si no está abierto el sidebar
      if (!document.querySelector('.mobile-sidebar.active')) {
        document.body.style.overflow = 'hidden';
      }
    }
  };

  // Efecto para escuchar cambios en el tema
  useEffect(() => {
    const handleThemeChange = () => {
      localStorage.getItem('theme' || 'dark');
      setCurrentTheme('dark');
    };

    // Escuchar el evento storage para detectar cambios en localStorage desde otras ventanas
    window.addEventListener('storage', handleThemeChange);

    // Escuchar el evento personalizado para cambios de tema dentro de la misma ventana
    //window.addEventListener('themeChanged', handleThemeChange);

    // Verificar el tema actual al montar el componente
    handleThemeChange();

    return () => {
      window.removeEventListener('storage', handleThemeChange);
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []); // Eliminamos la dependencia de currentTheme para evitar re-renders innecesarios

  const [usersuscriptor, setusersuscriptor] = useState(true);
  const [developer, setDeveloper] = useState(false);
  const [client, setClient] = useState(false);

  const [addingOrg, setaddingOrg] = useState(false)


  const [showModalImg, setShowModalImg] = useState(false);


  const [selectedImage, setSelectedImage] = useState(null);
  const [disabledButtonSendImg, setDisabledButtonSendImg] = useState(false);
  const [errorMsg, setError] = useState('');


  const [fileName, setFilename] = useState('Select File')

  const placeAvatar = 'data:image/png;base64,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'



  const handleClose = () => setShowModalImg(false);
  const [showOrgs, setShowOrgs] = useState(false);

  const handleOPrgs = () => {
    setShowOrgs(!showOrgs)
    setShowWorkspaceMenu(false);
  }

  let proye = [];


  const handleSubmit = async () => {
    // Aquí puedes enviar la imagen al servidor o realizar otras acciones necesarias
    // Restablece el estado después de enviar la imagen
    if (selectedImage) {

      setDisabledButtonSendImg(true);

      const safedstring = selectedImage.toString();
      const base64SafedString = btoa(safedstring);

      const payload = { image: base64SafedString };

      try {
        const result = await ObexRequestHandler.post('/update_avatar', payload);

        // debugger
        if (result.success && result.success == true) {
          setSelectedImage(null);
          setShowModalImg(false);
          setDisabledButtonSendImg(false);

          const output = document.getElementById('AvatarImageHeader') as HTMLImageElement;
          //console.log(output);
          //console.log(base64SafedString)
          output.src = safedstring;

          //getPersonalInformation(); //re-render
        } else {
          setError('Image too big');
          setDisabledButtonSendImg(false)

          setTimeout(() => {
            setError('');
          }, 2000);


        }

      } catch {
        setError('Image too big');
        setDisabledButtonSendImg(false)
      }

    } else {
      console.log('No se ha seleccionado ningún archivo');
      setDisabledButtonSendImg(false)
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      console.log(file);
      setFilename(file.name);
    }
  };

  const handleOrg = () => {

    console.log('RECUPERANDO PROYECTOS');
    SessionService.ORGANIZATIONS = null;
    SessionService.dispatchOrganizationChangedEvent();
    //await getProjects();
    setaddingOrg(!addingOrg);

  }


  const analyticsTags = [
    'G-MQZQJN7TQL',
    'G-98LF8608ZM',
    'G-KKCW4SZLW4',
    'G-EL6DCZWCM7',
    'G-5LKNTQFGD8',
    'G-11ZHMK4Y4Z',
    'G-PDYER55NCM'
  ];
  //ReactGA.initialize('UA-170480071-2');
  //analyticsTags.forEach(tag => {
  //  ReactGA.initialize(tag);
  //});

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    SessionService.logout();
    history.push('/cloud_login');

  }

  const getProjects = async () => {
    try {
      //console.log("PROG")
      setProjects([]);
      //console.log("PROG1")
      let projects = null;
      //console.log("PROG2")
      if (SessionService.ORGANIZATIONS == null) {
        //console.log('HACIENDO LLAMADA')
        projects = (await ObexRequestHandler.get('/organizations', {}, true)).data || [];
        SessionService.ORGANIZATIONS = projects
      }
      else {
        projects = SessionService.ORGANIZATIONS;
      }
      if (projects.length == 0) {
        setNameOrg('My Company');
        SessionService.ORGANIZATION_NAME = 'My Company';
        SessionService.ORGANIZATION = -1;
      } else {
        if (projects.result.length == 0) {
          setNameOrg('My Company');
          SessionService.ORGANIZATION_NAME = 'My Company';
          SessionService.ORGANIZATION = -1;
        }
      }

      setCurrentOrganizations(projects['result'].length);
      setMaxOrganizations(projects['max']);

      setProjects(projects['result']);

      if (projects['result'].length > 0) {
        if (SessionService.ORGANIZATION_NAME == null) {
          setNameOrg(projects['result'][0]['name']);
          SessionService.ORGANIZATION_NAME = projects['result'][0]['name'];
          SessionService.ORGANIZATION = projects['result'][0]['id'];
        } else {
          setNameOrg(SessionService.ORGANIZATION_NAME);
        }
      } else {
        SessionService.ORGANIZATION_NAME = 'Sin Organización';
        SessionService.ORGANIZATION = -1;
      }

    } catch (error) {
      console.error('ERROR FETCHING PROJECTS ', error);


    }

  }


  useEffect(() => {
    setIsDarkMode(false);
    console.log(localStorage.getItem('darkMode'))
    
    setCurrentTheme("light")
   
    setIsDarkMode(true);

    document.body.classList.add('cloudDashboard');
    document.body.classList.remove('dark-mode');

    if (false) {
      document.body.classList.add('dark-mode');
    } else {
      
    }

   if (true) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('darkMode', 'false'); // Guarda el modo oscuro en localStorage

      console.log(">>>>> DARKMODE")

    } 


    const dmode = localStorage.getItem('darkMode')
    console.log(`>>> ${dmode}`)

  }, [isDarkMode]);



  useEffect(() => {



    if (isLoggedIn) {
      window.location.replace('/cloud_login')
    }

    if (config.url != 'https://avs-primary-pre.101obex.mooo.com') ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Cloud' })//pageview(window.location.pathname + window.location.search);

    const user = cookies.get('101Obex');
    if (user) {
      //console.log('User data')
      //console.log(user);
      setDeveloper(SessionService.Developer);
      setusersuscriptor(SessionService.User);
      setClient(SessionService.Client);
      if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
        SessionService.renewSession();
      }
      setLogged(true);
      getProjects();
      //console.log("header", isDashboardBlue);

    }
  }, [])

  // Como este componente siempre está presente ponemos aquí el listener del inactivityEvent para que lancé el modal
  document.addEventListener('inactivityEvent', (e) => {

    e.preventDefault();
    e.stopPropagation();
    setInactivity(true);
  }, false);

  document.addEventListener('organizationsChange', (e) => {

    e.preventDefault();
    e.stopPropagation();
    getProjects();


    setNameOrg(SessionService.ORGANIZATIONS.result[0].name)


  }, false);

  //organizationsChange
  // Como este componente siempre está presente ponemos aquí el listener del sessionExpiredEvent para que lancé el modal
  document.addEventListener('sessionExpiredEvent', (e) => {

    if (sessionExpired) return;
    e.preventDefault();
    e.stopPropagation();
    setSessionExpired(true);
  }, false);

  const setName = (orga) => {

    setNameOrg(orga.name);
    SessionService.ORGANIZATION_NAME = orga.name;
    SessionService.ORGANIZATION = orga.id;
    //   history.push('/cloud_dashboard');
    return orga.name;
  }



  const renewSession = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      await SessionService.renewSession();
      setInactivity(false);
    } catch (error) {
      console.error(error);
    }
  }
  const handleModal = () => {

    setShowModal(!showModal);
    SessionService.ORGANIZATIONS = null;
    SessionService.dispatchOrganizationChangedEvent();
  };

  const on_Change = (event) => {
    const value = event.target.value;

    // this will return C:\fakepath\somefile.ext
    console.log(value);

    const files = event.target.files;

    //this will return an ARRAY of File object
    console.log(files);


    const input = event.target;

    const reader = new FileReader();
    reader.onload = function () {
      const dataURL = reader.result;
      const output = document.getElementById('output') as HTMLImageElement;
      output.src = dataURL.toString();
      console.log(dataURL)
    };
    reader.readAsDataURL(input.files[files.length - 1]);



  }

  // Efecto para cerrar el menú móvil cuando se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) &&
        !event.target.classList.contains('dp-mobile-menu-button') &&
        !event.target.closest('.dp-mobile-menu-button')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuRef]);

  return (
    <Fragment>
      <SessionExpired show={sessionExpired} handleHide={handleLogout} />
      <InactivityModal show={inactivity && !sessionExpired} renewSession={renewSession} closeSession={handleLogout} />

      {!isDashboardBlue && (
        <>
          <div id='devNav' className="dp-navbar">

            <div className={' my-auto'} style={{ display: 'flex', justifyContent: 'center' }}>
              <a href="/default">
                <img className="logo" src={currentTheme === 'dark' ? logoWhite : logo1} height={"30px"} style={{ marginLeft: '8px' }} />
              </a>
            </div>

            {/* 
              <Col className="my-auto">
                <Row className="menu-header justify-content-end align-items-center" style={{ width: '95.5%' }}>
                  <Col sm={1} style={{ minWidth: '250px' }}><a className={window.location.pathname === '/docs' ? 'link-2 fonsize14' : 'link link-header fonsize14'} onClick={() => history.push('/docs')} style={{ textAlign: 'center' }}>AVAP Language Specifications</a></Col>
                  <Col sm={1} ><a className={window.location.pathname === '/wiki' ? 'link-2 fonsize14' : 'link link-header fonsize14'} onClick={() => history.push('/wiki')} style={{ textAlign: 'center' }}>Docs</a></Col>

                  {isLoggedIn ?

                    <Col style={{ minWidth: '180px' }} sm={1}><a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header fonsize14" style={{ textAlign: 'center' }}>AVAP Communities</a></Col>
                    :
                    <Col sm={1} style={{ minWidth: '180px' }}> <a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header fonsize14" style={{ textAlign: 'center' }}>AVAP Communities</a></Col>

                  }

                  <Col sm={2}><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center' }}>
                    <div>
              
                      <button
                        style={{ marginLeft: '-4px', padding: '0px', width: '190px', height: '30px' }}
                        className='custom-button-green textBold'
                        onClick={() => { history.push('/login') }}
                      >
                        Login to AVAP ID
                      </button>
                    </div>
                  </a></Col>
                </Row>
              </Col> */}

            {/* Botón de menú móvil */}
            <button className="dp-mobile-menu-button header-menu-button" onClick={toggleMobileMenu}>
              <FontAwesomeIcon icon={faBars} />
            </button>

            <div className={`dp-header-menu-links ${mobileMenuOpen ? 'active' : ''}`} ref={mobileMenuRef}>

              <a className={window.location.pathname === '/docs' ? 'link-2 ' : 'link link-header '} onClick={() => { history.push('/docs'); setMobileMenuOpen(false); }}>AVAP Language Specifications</a>

              <a className={window.location.pathname === '/wiki' ? 'link-2 ' : 'link link-header '} onClick={() => { history.push('/wiki'); setMobileMenuOpen(false); }} >Docs</a>

              {isLoggedIn ?

                <a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header " onClick={() => setMobileMenuOpen(false)}>AVAP Communities</a>
                :
                <a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header " onClick={() => setMobileMenuOpen(false)}>AVAP Communities</a>

              }

              <button className="dp-ln-button-green" onClick={() => { history.push('/login'); setMobileMenuOpen(false); }}>
                Get a Demo
              </button>

              <button className="dp-gradient-button-green" onClick={() => { history.push('/login'); setMobileMenuOpen(false); }}>
                Start for Free
              </button>

              {/*       {isLoggedIn ?
              <span style={{ paddingRight: '20px', paddingTop: '10px', cursor: 'pointer' }} onClick={() => { SessionService.eventEmitter.emit('panel', 'Bob'); setMobileMenuOpen(false); }}><FontAwesomeIcon icon={faTerminal} /></span>


              :

              <></>
            } */}

            </div>



            {/*}
                    <div className="linksWrapper">
                      <a onClick={()=>history.push('/docs')}>API Products</a>
                      <a onClick={()=>history.push('/wiki')}>Documents</a> 
                    </div>

                    */}


            {/*}
                  <Col sm={2}><a className="link link-header fonsize14 cloudNav" onClick={() => history.push('/login')} style={{ textAlign: 'center' }}>
                    
                    
                    
                    <div>

                      <button
                        style={{ marginLeft: '-4px', padding: '0px', width: '190px', height: '30px' }}
                        className='custom-button-green textBold'
                        onClick={() => { history.push('/login') }}
                      >
                        Login to AVAP ID
                      </button>
                    </div>
                    
                  </a></Col>
                  */}







          </div>
        </>
      )}

      {isDashboardBlue && (
        <>
          <Row style={{ justifyContent: 'center', marginLeft: '0px' }} className="py-0 px-2 cloudNav" id="header">

            <Row style={{ width: '100%' }}>

              {/* IM REMOVE THIS */}
              <div className={'pl-3 my-auto'} style={{ cursor: 'pointer' }} onClick={() => { history.push('/cloud_dashboard') }}>
                <img src={isDarkMode ? cld_icn_dark : cld_icn} alt="Cloud Icon" className="cld_logo" />
                {/*}
                <svg className="cld_logo" width="315" height="57" viewBox="0 0 315 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M196.996 26.8991C196.996 18.4501 203.466 12.3461 212.156 12.3461C214.16 12.2753 216.156 12.6218 218.019 13.3636C219.882 14.1054 221.57 15.2262 222.976 16.655C223.027 16.7084 223.067 16.7712 223.093 16.84C223.12 16.9087 223.133 16.982 223.131 17.0557C223.129 17.1294 223.113 17.202 223.083 17.2693C223.053 17.3366 223.01 17.3974 222.956 17.4481L220.356 19.8941C220.253 19.9926 220.115 20.0476 219.972 20.0476C219.829 20.0476 219.692 19.9926 219.588 19.8941C218.649 18.9455 217.529 18.1967 216.293 17.6926C215.057 17.1886 213.732 16.9397 212.398 16.961C206.536 16.961 202.291 21.0851 202.291 26.9071C202.291 32.7291 206.536 36.8531 212.398 36.8531C213.736 36.8757 215.063 36.6243 216.3 36.1143C217.536 35.6044 218.655 34.8468 219.588 33.8881C219.691 33.7865 219.828 33.7289 219.973 33.7274C220.117 33.7259 220.256 33.7807 220.36 33.8801L222.96 36.3581C223.013 36.409 223.056 36.47 223.086 36.5374C223.115 36.6049 223.131 36.6776 223.133 36.7512C223.134 36.8249 223.121 36.8981 223.094 36.9667C223.067 37.0354 223.027 37.098 222.976 37.1511C221.564 38.5844 219.869 39.708 217.998 40.4506C216.128 41.1931 214.124 41.5382 212.113 41.4641C203.463 41.4641 196.993 35.364 196.993 26.911L196.996 26.8991Z" />
                    <path d="M228.479 11.05H232.418C232.565 11.0503 232.706 11.1089 232.81 11.2129C232.914 11.3169 232.973 11.4579 232.973 11.605V40.489C232.973 40.6362 232.914 40.7772 232.81 40.8812C232.706 40.9852 232.565 41.0438 232.418 41.044H228.479C228.332 41.0438 228.191 40.9852 228.087 40.8812C227.983 40.7772 227.925 40.6362 227.924 40.489V11.6091C227.925 11.4619 227.983 11.3209 228.087 11.2169C228.191 11.1129 228.332 11.0543 228.479 11.0541V11.05Z" />
                    <path d="M237.825 30.253C237.825 23.783 242.677 19.217 249.308 19.217C255.939 19.217 260.831 23.784 260.831 30.253C260.831 36.722 256.019 41.329 249.308 41.329C242.597 41.329 237.825 36.723 237.825 30.253ZM255.733 30.253C255.733 26.129 252.985 23.502 249.304 23.502C245.623 23.502 242.915 26.129 242.915 30.253C242.915 34.377 245.663 37.004 249.304 37.004C252.945 37.004 255.733 34.377 255.733 30.253Z" />
                    <path d="M286.582 20.0181V40.4931C286.582 40.6402 286.523 40.7812 286.419 40.8853C286.315 40.9893 286.174 41.0478 286.027 41.0481H282.327C282.18 41.0478 282.039 40.9893 281.935 40.8853C281.831 40.7812 281.772 40.6402 281.772 40.4931V39.6641C281.772 39.5579 281.741 39.454 281.684 39.3647C281.627 39.2753 281.545 39.2043 281.448 39.1599C281.352 39.1155 281.245 39.0997 281.14 39.1142C281.035 39.1288 280.936 39.1732 280.855 39.2421C279.159 40.6389 277.017 41.3799 274.82 41.3301C269.28 41.3301 265.52 38.2961 265.52 31.7911V20.0181C265.52 19.871 265.579 19.73 265.683 19.626C265.787 19.5219 265.928 19.4634 266.075 19.4631H270.014C270.161 19.4634 270.302 19.5219 270.406 19.626C270.51 19.73 270.569 19.871 270.569 20.0181V31.1031C270.569 35.0261 272.428 36.8851 275.622 36.8851C279.138 36.8851 281.522 34.7001 281.522 30.3751V20.0141C281.522 19.867 281.581 19.726 281.685 19.622C281.789 19.5179 281.93 19.4594 282.077 19.4591H286.016C286.163 19.4594 286.304 19.5179 286.408 19.622C286.512 19.726 286.571 19.867 286.571 20.0141L286.582 20.0181Z" />
                    <path d="M314.349 11.6091V40.4941C314.349 40.6412 314.29 40.7822 314.186 40.8862C314.082 40.9903 313.941 41.0488 313.794 41.0491H310.056C309.983 41.0493 309.911 41.0352 309.843 41.0074C309.776 40.9797 309.714 40.9388 309.662 40.8873C309.61 40.8357 309.569 40.7745 309.541 40.707C309.513 40.6395 309.498 40.5672 309.498 40.4941V39.6291C309.498 39.5225 309.467 39.4183 309.409 39.3287C309.352 39.2391 309.27 39.168 309.173 39.1236C309.076 39.0792 308.968 39.0635 308.863 39.0783C308.757 39.0931 308.658 39.1378 308.577 39.2071C306.83 40.6566 304.61 41.4126 302.341 41.3311C296.077 41.3311 291.426 36.9661 291.426 30.2551C291.426 23.5441 296.077 19.2191 302.341 19.2191C304.531 19.1463 306.674 19.8585 308.384 21.2271C308.465 21.2946 308.564 21.3376 308.669 21.3511C308.774 21.3646 308.88 21.3481 308.976 21.3035C309.072 21.2588 309.153 21.1879 309.209 21.0989C309.266 21.01 309.297 20.9067 309.297 20.8011V11.6091C309.298 11.462 309.356 11.3209 309.46 11.2169C309.564 11.1129 309.705 11.0543 309.852 11.0541H313.798C313.945 11.0543 314.086 11.1129 314.19 11.2169C314.294 11.3209 314.353 11.462 314.353 11.6091H314.349ZM309.376 30.2541C309.376 26.1301 306.588 23.5031 302.947 23.5031C299.306 23.5031 296.518 26.1301 296.518 30.2541C296.518 34.3781 299.306 37.0051 302.947 37.0051C306.588 37.0051 309.376 34.3771 309.376 30.2541Z" />
                    <path d="M85.489 12.996C85.4542 12.9191 85.398 12.854 85.327 12.8084C85.256 12.7628 85.1733 12.7387 85.089 12.739H81.605C81.5206 12.7387 81.4379 12.7628 81.367 12.8084C81.296 12.854 81.2397 12.9191 81.205 12.996L68.691 40.373C68.6604 40.4399 68.6472 40.5133 68.6525 40.5866C68.6578 40.6599 68.6815 40.7307 68.7213 40.7925C68.7612 40.8542 68.8159 40.905 68.8805 40.94C68.9451 40.9751 69.0175 40.9933 69.091 40.993H73.259C73.3434 40.9939 73.4263 40.97 73.4974 40.9243C73.5685 40.8787 73.6246 40.8132 73.659 40.736L82.929 20.036C82.9638 19.9591 83.02 19.8938 83.0909 19.848C83.1619 19.8023 83.2445 19.7779 83.329 19.7779C83.4134 19.7779 83.496 19.8023 83.567 19.848C83.6379 19.8938 83.6942 19.9591 83.729 20.036L92.999 40.736C93.0337 40.8129 93.09 40.8781 93.161 40.9237C93.2319 40.9693 93.3146 40.9934 93.399 40.993H97.607C97.6805 40.9933 97.7528 40.9751 97.8174 40.94C97.882 40.905 97.9368 40.8542 97.9766 40.7925C98.0165 40.7307 98.0401 40.6599 98.0454 40.5866C98.0507 40.5133 98.0375 40.4399 98.007 40.373L85.485 12.996H85.489Z" />
                    <path d="M122.377 13.013H118.293C118.208 13.0122 118.124 13.0367 118.053 13.0833C117.982 13.13 117.926 13.1967 117.893 13.275L108.977 33.371C108.942 33.448 108.886 33.5132 108.815 33.559C108.744 33.6048 108.661 33.6292 108.577 33.6292C108.493 33.6292 108.41 33.6048 108.339 33.559C108.268 33.5132 108.212 33.448 108.177 33.371L99.318 13.271C99.2838 13.1933 99.2279 13.1272 99.1569 13.0806C99.0858 13.0341 99.0028 13.0093 98.9179 13.009H94.645C94.5718 13.0086 94.4997 13.0265 94.4353 13.0612C94.3709 13.0959 94.3162 13.1462 94.2764 13.2076C94.2365 13.2689 94.2128 13.3393 94.2073 13.4123C94.2018 13.4852 94.2148 13.5584 94.245 13.625L106.371 41.004C106.405 41.0819 106.461 41.1481 106.532 41.1946C106.603 41.2411 106.686 41.266 106.771 41.266H110.263C110.348 41.2669 110.432 41.2424 110.503 41.1958C110.574 41.1491 110.63 41.0824 110.663 41.004L122.777 13.629C122.807 13.5624 122.819 13.4893 122.813 13.4166C122.808 13.3439 122.784 13.2737 122.744 13.2125C122.704 13.1513 122.65 13.101 122.586 13.0662C122.522 13.0313 122.45 13.0131 122.377 13.013Z" />
                    <path d="M162.295 13.0131H151.895C151.779 13.0133 151.667 13.0597 151.585 13.1419C151.503 13.2242 151.456 13.3357 151.456 13.4521V40.8311C151.456 40.9474 151.503 41.0589 151.585 41.1412C151.667 41.2235 151.779 41.2698 151.895 41.2701H155.834C155.95 41.2698 156.062 41.2235 156.144 41.1412C156.226 41.0589 156.273 40.9474 156.273 40.8311V33.4311C156.273 33.3147 156.32 33.2032 156.402 33.1209C156.484 33.0387 156.596 32.9923 156.712 32.9921H162.292C169.526 32.9921 174.02 29.1701 174.02 23.0221C174.02 16.8741 169.526 13.0161 162.292 13.0161L162.295 13.0131ZM162.219 28.5131H156.719C156.603 28.5128 156.491 28.4665 156.409 28.3842C156.327 28.3019 156.28 28.1904 156.28 28.0741V17.8891C156.28 17.7727 156.327 17.6612 156.409 17.5789C156.491 17.4967 156.603 17.4503 156.719 17.4501H162.219C164.111 17.3143 165.99 17.8391 167.538 18.9351C168.109 19.4438 168.557 20.076 168.847 20.7837C169.137 21.4914 169.262 22.2559 169.212 23.0191C169.212 27.5611 165.412 28.5111 162.219 28.5111V28.5131Z" />
                    <path d="M135.749 13.2701C135.714 13.1932 135.658 13.128 135.587 13.0824C135.516 13.0368 135.433 13.0127 135.349 13.0131H131.871C131.786 13.0127 131.704 13.0368 131.633 13.0824C131.562 13.128 131.505 13.1932 131.471 13.2701L118.951 40.6501C118.92 40.7169 118.907 40.7904 118.912 40.8637C118.918 40.937 118.941 41.0078 118.981 41.0695C119.021 41.1313 119.076 41.182 119.14 41.2171C119.205 41.2521 119.277 41.2703 119.351 41.2701H123.519C123.603 41.2709 123.686 41.247 123.757 41.2014C123.828 41.1557 123.884 41.0903 123.919 41.0131L133.189 20.3131C133.224 20.2361 133.28 20.1709 133.351 20.1251C133.422 20.0793 133.504 20.055 133.589 20.055C133.673 20.055 133.756 20.0793 133.827 20.1251C133.898 20.1709 133.954 20.2361 133.989 20.3131L143.259 41.0131C143.293 41.0899 143.35 41.1551 143.421 41.2007C143.492 41.2463 143.574 41.2704 143.659 41.2701H147.867C147.94 41.2703 148.013 41.2521 148.077 41.2171C148.142 41.182 148.197 41.1313 148.236 41.0695C148.276 41.0078 148.3 40.937 148.305 40.8637C148.31 40.7904 148.297 40.7169 148.267 40.6501L135.745 13.2701H135.749Z" />
                    <path d="M176.839 14.731H178.151V18.066H179.032V14.731H180.344V13.963H176.844L176.839 14.731Z" />
                    <path d="M185.385 13.963H184.669L183.169 16.514L181.64 13.963H180.924V18.063H181.769V15.663L182.956 17.61H183.366L184.553 15.631V18.065H185.394L185.385 13.963Z" />
                    <path d="M49.6681 12.993L27.7331 0.480983C27.1886 0.171346 26.573 0.00854492 25.9466 0.00854492C25.3202 0.00854492 24.7046 0.171346 24.1601 0.480983L2.02813 13.09C1.47876 13.4026 1.02118 13.8541 0.701237 14.3992C0.38129 14.9443 0.210207 15.5639 0.205125 16.196L0.000125238 40.871C-0.00526367 41.5176 0.163349 42.1539 0.4883 42.713C0.81325 43.2721 1.28258 43.7336 1.84713 44.049L24.1241 56.538C24.6671 56.842 25.2793 57.001 25.9017 56.9996C26.524 56.9982 27.1355 56.8364 27.6771 56.53L49.6771 44.009C50.2308 43.6933 50.6912 43.2367 51.0113 42.6856C51.3315 42.1344 51.5002 41.5084 51.5001 40.871V16.131C51.5001 15.4941 51.3314 14.8687 51.0111 14.3182C50.6909 13.7677 50.2307 13.3119 49.6771 12.997L49.6681 12.993Z" fill="#0073C4" />
                    <path d="M49.6851 12.993L27.7381 0.473026C27.1332 0.127976 26.4413 -0.0342428 25.7461 0.00602553V56.997C26.4171 57.0317 27.0845 56.8783 27.6731 56.554L49.6811 44.03C50.2349 43.7141 50.6955 43.2576 51.0164 42.7066C51.3372 42.1556 51.5068 41.5296 51.5081 40.892V16.136C51.5076 15.4987 51.3388 14.8729 51.0186 14.3218C50.6985 13.7708 50.2385 13.3141 49.6851 12.998V12.993Z" fill="#007BD4" />
                    <path d="M49.7168 41.797H21.6698C19.9094 41.7974 18.1775 41.3512 16.6363 40.5003C15.0951 39.6493 13.7949 38.4215 12.8573 36.9314C11.9196 35.4414 11.3752 33.7379 11.2749 31.9803C11.1745 30.2227 11.5216 28.4683 12.2836 26.8812C13.0456 25.2942 14.1976 23.9263 15.632 22.9056C17.0664 21.8848 18.7362 21.2445 20.4853 21.0444C22.2344 20.8444 24.0056 21.0913 25.6334 21.7619C27.2611 22.4325 28.6922 23.505 29.7928 24.879C30.0285 25.1733 30.3199 25.4183 30.6503 25.5998C30.9807 25.7814 31.3437 25.896 31.7185 25.9372C32.0933 25.9783 32.4725 25.9452 32.8344 25.8396C33.1964 25.7341 33.5339 25.5582 33.8278 25.322L33.8798 25.282C34.4024 24.8642 34.7613 24.2759 34.8938 23.62C35.5303 20.5689 37.0906 17.7877 39.3628 15.6542C41.6349 13.5207 44.5087 12.1384 47.5938 11.695L40.8038 7.81604C36.3536 9.92981 32.7876 13.5401 30.7288 18.016C29.1753 16.9634 27.4491 16.1914 25.6288 15.735C23.4084 15.1717 21.0935 15.0871 18.8379 15.487C16.5823 15.8868 14.4375 16.7618 12.5459 18.054C10.6543 19.3462 9.05929 21.0259 7.86662 22.9818C6.67396 24.9376 5.91097 27.1248 5.62831 29.3981C5.34565 31.6713 5.54979 33.9788 6.22716 36.1671C6.90454 38.3555 8.03966 40.3747 9.55717 42.0908C11.0747 43.8068 12.9399 45.1805 15.0289 46.1205C17.118 47.0605 19.3831 47.5454 21.6738 47.543H43.7738L49.7288 44.155C50.1835 43.8961 50.577 43.5421 50.8825 43.1172C51.188 42.6923 51.3982 42.2065 51.4988 41.693C50.9101 41.7639 50.3178 41.8003 49.7248 41.802L49.7168 41.797Z" fill="white" />
                  </svg> 
              {/*}  </a> */}
              </div>

              <div className="my-auto col mx-0 px-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div className='d-flex align-items-center'>

                  </div>

                  <div className='d-flex align-items-center'>
                    <div>
                      {isLoggedIn ?
                        <Dropdown onToggle={handleOPrgs} style={{ width: '180px' }} className='my-auto orgDropdown pr-2'>

                          <Dropdown.Toggle style={{ width: '100%', textAlign: 'start' }} id='fonto'>
                            <img src={(isDarkMode) ? icon_org : icon_org_w} style={{ marginTop: '-1px', marginRight: '10px' }} height={'15px'} alt="Workspace Menu" />
                            {nombreOrganizacion}
                            
                            <span><FontAwesomeIcon icon={showOrgs ? faChevronUp : faChevronDown} /></span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ width: '100%' }} className='fonsize14 menu_organizations'>

                            {projects.map(x => {

                              return (<Dropdown.Item style={{ width: '100%' }} key={x.id} onClick={() => {
                                setName(x)

                                SessionService.updating = 5;
                                SessionService.dispatchUpdateViewEvent();

                              }



                              } className="fonsize14">{x.name}</Dropdown.Item>);

                            })}


                            {/* {currentOrganizations < maxOrganizations ?
                              <Dropdown.Item onClick={() => { setShowModal(true) }}>Create Organization</Dropdown.Item>
                              :
                              <Dropdown.Item onClick={() => { setaddingOrg(true) }}>Create Organization</Dropdown.Item>

                            } */}

                          </Dropdown.Menu>{' '}
                        </Dropdown>

                        :
                        <span></span>

                      }


                    </div>

                    <div>

                      {/*}
                      {isLoggedIn ? (
                        <>
                          <div className='pr-4'><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center', color: "#000" }}>
                            <div onClick={handleLogout}>
                              Sign out
                            </div>
                          </a></div>
                        </>
                      ) :
                        <>
                          <div ><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center' }}>
                            <div>
                              Sign In <span className='fonsize12'>→</span>
                            </div>
                          </a></div>
                        </>
                      }

                    */}



                    </div>

                    <button ref={menuAnchorRef} onClick={() => {
                      toggleWorkspaceMenu()
                    }
                    } className="workspace-button">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0H4V4H0V0ZM6 0H10V4H6V0ZM12 0H16V4H12V0ZM0 6H4V10H0V6ZM6 6H10V10H6V6ZM12 6H16V10H12V6ZM0 12H4V16H0V12ZM6 12H10V16H6V12ZM12 12H16V16H12V12Z"  />
                      </svg>

                    </button>

{/*Comentar Aquí Inicio*/}
                   {/* <button style={{ marginLeft: '10px' }} onClick={
                      () => {
                        localStorage.setItem('darkMode', `${isDarkMode ? 'false' : 'true'}`)

                        const arrow = document.getElementById('arrow-icon') as HTMLImageElement

                        arrow.src = (isDarkMode ? arrowMenu_B : arrowMenu_W)

                        //icon-IAM
                        const iconIAM = document.getElementById('icon-IAM') as HTMLImageElement
                        console.log(iconIAM)
                        iconIAM.style.backgroundImage = `url(${(isDarkMode ? IAM_B : IAM_W)})`

                        const iconCM = document.getElementById('icon-Credential Manager') as HTMLImageElement
                        iconCM.style.backgroundImage = `url(${(isDarkMode ? cManager_B : cManager_W)})`


                        const iconAP = document.getElementById('icon-API Projects') as HTMLImageElement
                        iconAP.style.backgroundImage = `url(${(isDarkMode ? Projects_B : Projects_W)})`

                        const iconAPb = document.getElementById('icon-API Publisher') as HTMLImageElement
                        iconAPb.style.backgroundImage = `url(${(isDarkMode ? Publisher_B : Publisher_W)})`

                        const iconAPc = document.getElementById('icon-API Catalog') as HTMLImageElement
                        iconAPc.style.backgroundImage = `url(${(isDarkMode ? catalog_B : catalog_W)})`

                        const iconDP = document.getElementById('icon-Dev Portal') as HTMLImageElement
                        iconDP.style.backgroundImage = `url(${(isDarkMode ? devPortal_B : devPortal_W)})`


                        const iconBr = document.getElementById('icon-Brunix') as HTMLImageElement
                        iconBr.style.backgroundImage = `url(${(isDarkMode ? ia_B : ia_W)})`


                        const iconGr = document.getElementById('icon-AI Analytics') as HTMLImageElement
                        iconGr.style.backgroundImage = `url(${(isDarkMode ? graph_B : graph_W)})`



                        const iconGM = document.getElementById('icon-Gateway Manager') as HTMLImageElement
                        iconGM.style.backgroundImage = `url(${(isDarkMode ? gateway_B : gateway_W)})`

                        const iconPU = document.getElementById('icon-Plan & Usage') as HTMLImageElement
                        iconPU.style.backgroundImage = `url(${(isDarkMode ? Sub_B : Sub_W)})`

                        const iconBI = document.getElementById('icon-Billing') as HTMLImageElement
                        iconBI.style.backgroundImage = `url(${(isDarkMode ? Billing_B : Billing_W)})`

                        const iconTU = document.getElementById('icon-Tutorials') as HTMLImageElement
                        iconTU.style.backgroundImage = `url(${(isDarkMode ? Tutorial_B : Tutorial_W)})`

                        const iconSO = document.getElementById('icon-Sign out') as HTMLImageElement
                        iconSO.style.backgroundImage = `url(${(isDarkMode ? SignOut_B : SignOut_W)})`

                        const iconDB = document.getElementById('icon-Dashboard') as HTMLImageElement
                        iconDB.style.backgroundImage = `url(${(isDarkMode ? Dashboard_B : Dashboard_W)})`




                        setIsDarkMode(!isDarkMode)


                      }
                    } className="cld-theme-button">
                      {<img style={{ width: '20px' }} src={isDarkMode ? sun : moon} alt="Workspace Menu" />}
                    </button>*/}

{/*Comentar Aquí Fin*/}
                    
                    {/*}
                    <button style={{ marginLeft: '-7px' }} onClick={null} className="workspace-button">
                      <img style={{ width: '17px' }} src={bell} alt="Workspace Menu" />
                    </button>
*/}



                    <div>
                      {isLoggedIn ?
                        <>
                        { false &&
                          <div className="user text-right my-auto pr-2">
                            <Dropdown className="mr-1">
                              <Dropdown.Toggle onClick={() => { setShowModalImg(true) }} className="link-user" id="obex-user-menu"><div style={{ height: '25px', width: '25px', borderRadius: '50% !important' }}><Image id='AvatarImageHeader' style={{ height: '25px', borderRadius: '50%' }} src={isDarkMode ? SessionService.ImageContentLight : SessionService.imageContent} /></div></Dropdown.Toggle>
                              {/*}
                              <Dropdown.Menu>
                                {usersuscriptor && <Dropdown.Item onClick={() => {
                                  history.push('/cloud_dashboard')
                                }}><h5>Administrator Dashboard</h5></Dropdown.Item>}
                                {developer && <Dropdown.Item onClick={() => {
                                  SessionService.ORGANIZATION_NAME = null;
                                  history.push('/devdashboard')
                                }}>Developer Dashboard</Dropdown.Item>}
                                {client && <Dropdown.Item onClick={() => {
                                  SessionService.ORGANIZATION_NAME = null;
                                  history.push('/clientdashboard')
                                }}>Client Dashboard</Dropdown.Item>}
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                              </Dropdown.Menu>{' '}
                              */}
                            </Dropdown>
                          </div>
}
                        </>
                        :
                        <>
                          <div className="login text-right my-auto">
                            <a href="/cloud_login" className="customButton-blue">Login to Developer Portal</a>
                          </div>
                        </>
                      }

                    </div>

                  </div>






                </div>
              </div>





              {/* <Col md={1}>
  <SelectLanguage/>
</Col>*/}


            </Row>
          </Row>
        </>
      )}


      <Modal  
        style={{ with: '40%', borderRadius: '8px' }}
        show={showModalImg} onHide={handleClose}
        id="modalImg"
        dialogClassName="addons-dialog themeDialog w-40 obex-dialog welcomeModal cloudModal" 
        container={document.getElementById('dashboardWrapper')}>
        
        <Modal.Header closeButton className="border-0 pb-0">
          <Col style={{ textAlign: 'center' }}>
            <Modal.Title className='textBold title' style={{ fontSize: '1.5rem', color: 'black' }}>Select an image for your avatar</Modal.Title>
          </Col>
        </Modal.Header>
        <Modal.Body style= {{borderRadius: '8px'}} className=''>
          <Form >
            <Row>
              <Col>
                <Form.Group controlId="formFile" className='m-0 customUploadFile'>
                  {/*<Form.Control className='btn  custom-button' style={{margin:'20px'}} type="file" accept=".jpg,.jpeg,.png" onChange=
              {handleFileChange} />*/}

                  <label htmlFor="file-upload" className="customButton-blue">
                    Select a new Image
                  </label>

                  <input id="file-upload" type="file" accept='image/*' className='btn custom-button input-field ' hidden
                    onChange={
                      handleFileChange
                    }
                  />      <span className='fontSizeTitleCard '>{fileName}</span>
                  {/* Mostrar la vista previa de la imagen seleccionada */}
                </Form.Group>
              </Col>
            </Row>
            <div style={{ maxHeight: '300px', overflow: 'hidden' }} className='d-flex justify-content-center align-items-center'>
              <img src={selectedImage == undefined ? placeAvatar : selectedImage} alt="Preview" style={{ maxHeight: '300px', aspectRatio: 'auto ', paddingTop: '20px', maxWidth: '30%', marginTop: '40px', marginBottom: '40px' }} />
            </div>

          </Form>
          {errorMsg != '' && <Alert variant='danger'>{errorMsg}</Alert>}

        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center w-100'>
            <button className="customButton-blue" onClick={handleSubmit} disabled={disabledButtonSendImg}>Save</button>

          </div>
        </Modal.Footer>
      </Modal>




      {(addingOrg) && <AddOrganizationSlots shown={addingOrg} onCloseAction={handleOrg} onSuccess={handleOrg} MaxDBSize={1} ActualDBSize={0} />}

      {showModal && <AddOrganizationModal opened={showModal} updateTable={null} show={showModal} handleClose={handleModal} regions={[]} organization_devs={[]} deployments={[]} />}

      {/* workspace module */}
      <WorkspaceMenu
        show={showWorkspaceMenu}

        handleClose={() => {
          setDelayClick(1)
          setShowWorkspaceMenu(false)
        }/*() => setShowWorkspaceMenu(false)*/}
      />
    </Fragment>
  );
}

export default Header;